<script lang="ts">
  import { cn } from "$lib/utils/cn";

  interface Props {
    type?: string;
    value?: string;
    placeholder?: string;
    disabled?: boolean;
    class?: string;
    oninput?: (e: Event) => void;
  }

  let {
    type = "text",
    value = $bindable(""),
    placeholder,
    disabled = false,
    class: className,
    oninput,
    ...restProps
  }: Props = $props();
</script>

<input
  {type}
  bind:value
  {placeholder}
  {disabled}
  {oninput}
  class={cn(
    "w-full h-9 px-3 text-sm",
    "bg-surface-3 border border-border-default rounded",
    "text-text-primary placeholder:text-text-muted",
    "focus:outline-none focus:border-accent-primary focus:ring-1 focus:ring-accent-primary/20",
    "disabled:opacity-50 disabled:cursor-not-allowed",
    "transition-colors",
    className
  )}
  {...restProps}
/>
